import axios from "axios";

const BASE_URL = "";

const departmentService = {
  // Fetch all departments
  async getDepartments() {
    try {
      const response = await axios.get(`${BASE_URL}/UserDetails/Department`);
      
      console.log("Department API response:", response.data);
      
      if (response.data && response.data.statusCode === 200 && response.data.resultSet) {
        // Transform the API response to match component's expected format
        return response.data.resultSet.map(item => ({
          depCode: item.depCode,
          depName: item.depName,
          locCode: item.locCode,
          locName: item.locName
        }));
      } else {
        console.warn("Unexpected API response structure:", response.data);
        return [];
      }
    } catch (error) {
      console.error("Error fetching departments:", error);
      throw error;
    }
  }
};

export default departmentService;
